import React, { useCallback } from 'react';
import Layout from '../Layout';
import {
  Box,
  Button,
  Container,
  Divider,
  Flex,
  Icon,
  IconButton,
  Radio,
  RadioGroup,
  Spinner,
  Stack,
  Text,
  Textarea,
} from '@chakra-ui/react';

import { FaChevronLeft, FaChevronRight } from 'react-icons/fa6';
import QuizCardBody from './QuizCardBody';

const QuizCard = ({
  index,
  question,
  answer,
  handleQuestionIndex,
  totalQuestions,
  userResponses,
  handleSaveResponse,
}) => {
  const quizHeaderRenderer = useCallback(() => {
    return (
      <Box>
        {answer && (
          <Flex justifyContent="space-between" p={4} mb={4}>
            <Icon
              as={FaChevronLeft}
              color="#101828"
              p="0.5rem"
              w="2rem"
              height="2rem"
              cursor="pointer"
              onClick={() => handleQuestionIndex('prev')}
            />
            <Icon
              as={FaChevronRight}
              color="#101828"
              p="0.5rem"
              w="2rem"
              height="2rem"
              cursor="pointer"
              onClick={() => handleQuestionIndex('next')}
            />
          </Flex>
        )}

        <Text fontSize="34px" color="#1b254b" fontWeight="700">
          Question {index + 1}
        </Text>
      </Box>
    );
  }, [index, answer, handleQuestionIndex]);

  const quizBodyRenderer = useCallback(() => {
    return (
      <QuizCardBody
        question={question}
        answer={answer}
        handleQuestionIndex={handleQuestionIndex}
        totalQuestions={totalQuestions}
        currentIndex={index}
        userResponses={userResponses}
        handleSaveResponse={handleSaveResponse}
      />
    );
  }, [
    question,
    answer,
    handleQuestionIndex,
    totalQuestions,
    index,
    userResponses,
    handleSaveResponse,
  ]);

  return (
    <>
      {!question ? (
        <Flex
          justifyContent="center"
          mt="2rem"
          alignItems="center"
          height="20rem"
        >
          <Spinner
            thickness="4px"
            speed="0.8s"
            emptyColor="gray.200"
            color="blue.500"
            size="xl"
          />
        </Flex>
      ) : (
        <Layout
          header={quizHeaderRenderer}
          body={quizBodyRenderer}
          hasGenericFooter={true}
        />
      )}
    </>
  );
};

export default QuizCard;
